import SEO from "@/components/SEO";
import { Reveal } from "@/components/Reveal";
import ChapterOnePlayer from "@/components/ChapterOnePlayer";

// Private audio resource page — mirrors the Quiet Mind page structure.
const ResourceAudioPage = ({ title, subtitle, label, src, testId }) => (
  <>
    <SEO title={`${title} — A guided audio practice by Tara Aurora`} description={subtitle} noindex />

    <section data-testid={testId} className="relative overflow-hidden grain border-b border-stone/60">
      <div
        aria-hidden="true"
        className="absolute -top-24 left-1/3 w-[36vw] max-w-[440px] aspect-square rounded-full bg-[radial-gradient(circle,rgba(76,144,128,0.08),transparent_65%)] blur-3xl anim-orb"
      />
      <div className="relative mx-auto max-w-3xl px-6 md:px-10 pt-40 md:pt-52 pb-24 md:pb-32">
        <Reveal>
          <p className="eyebrow mb-6 text-center">A Free Resource</p>
          <h1
            className="font-serif text-5xl md:text-6xl lg:text-7xl tracking-tight leading-[1.08] text-center"
            data-testid={`${testId}-title`}
          >
            {title}
          </h1>
        </Reveal>
        <Reveal delay={0.15}>
          <p
            className="mt-8 text-base md:text-lg leading-relaxed text-taupe max-w-xl mx-auto text-center"
            data-testid={`${testId}-subtitle`}
          >
            {subtitle}
          </p>
        </Reveal>

        <Reveal delay={0.25}>
          <div className="mt-14 md:mt-16 border border-stone bg-white/60 p-8 md:p-12" data-testid={`${testId}-player`}>
            <ChapterOnePlayer src={src} label={label} />
          </div>
        </Reveal>

        <Reveal delay={0.35}>
          <p
            className="mt-10 font-serif italic text-lg md:text-xl text-deepteal leading-relaxed text-center max-w-lg mx-auto"
            data-testid={`${testId}-instruction`}
          >
            Find a comfortable place where you can be undisturbed for a few
            minutes. You don't need to do anything perfectly. Just listen.
          </p>
        </Reveal>
      </div>
    </section>
  </>
);

export default ResourceAudioPage;
